import React from 'react';
import TargetGroup from '../component/page/targetGroup';
import NumberOfMembers from '../component/page/numberOfMembers';
import StartOrResume from '../component/page/startOrResume';
import Animation from '../component/page/Animation';
import WaitingForPlayers from '../component/page/WaitingForPlayer';
import Question from '../component/page/question';
import GameTimer from '../component/page/gameTimer';
import RulesOfConduct from '../component/page/RulesOfConduct';
import GameFlow from '../component/page/GameFlow';
import Tool from '../component/page/Tool';
import StartLevel from '../component/page/StartLevel';
import ResultMultipleChoice from '../component/page/ResultMultipleChoice';
import ResultAB from '../component/page/ResultAB';
import ResultTool from '../component/page/ResultTool';
import ResultCloud from '../component/page/ResultCloud';
import EndCredits from '../component/page/EndCredits';
import {publicBuildUrl} from './config';

const map = [
    <TargetGroup/>,
    <NumberOfMembers/>,
    <StartOrResume/>,
    <WaitingForPlayers/>,
    <RulesOfConduct hasNextButton={true}/>,
    <GameFlow hasNextButton={true}/>,
    <Tool hasNextButton={true}/>,

    /**
     * Milan
     */
    <StartLevel level={1}
                text={'Het verhaal van Milan.'}
                navigateTo={2}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level1Animation1.mp4`}/>,
    <Question seconds={30} title={'Wat valt je op?'} context={'Maak een keuze\n(meerdere antwoorden zijn correct)'}/>,
    <ResultMultipleChoice question={'Wat valt je op?'}
                          answer={[1, 0, 1, 1]}
                          options={[
                              'Kapotte kleren',
                              'Kijkt blij',
                              'Wondje op zijn hoofd',
                              'Verband om zijn arm',
                          ]}
                          screenshot={`${publicBuildUrl}images/screenshots/Level1Question1.png`}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level1Animation2.mp4`}/>,
    <Question seconds={30} title={'Heeft Milan eten om mee naar school te nemen?'} context={'Maak een keuze'}/>,
    <ResultAB id={101}
              question={'Neemt Milan eten mee naar school?'}
              answer={2}
              percentages={[12, 88]}
              screenshot={`${publicBuildUrl}images/screenshots/Level1Question2.png`}
              text={'Nee, Milan neemt geen eten mee naar school omdat het eten dat in de koelkast ligt niet meer gegeten kan worden.'}
    />,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level1Animation3.mp4`}/>,
    <GameTimer text={'Probeer in 30 seconden zo snel mogelijk de cijfers van laag naar hoog aan te tikken om zo een highscore te behalen.'}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level1Animation4.mp4`}/>,
    <Question
        seconds={90}
        title={'Is de situatie van Milan wel of niet oké?'}
        context={'Beoordeel aan de hand van de tool ‘Miro’ of de situatie van Milan wel of niet oké is.'}
    />,
    <ResultTool id={102}
                navigateDeviceNext={true}
                questions={[
                    'Is er in de situatie van Milan sprake van een goede context?',
                    'Is er in de situatie van Milan sprake van bescherming?',
                    'Is er in de situatie van Milan sprake van voldoende aandacht?',
                    'Is er in de situatie van Milan sprake van vrijwilligheid?',
                    'Is er in de situatie van Milan sprake van wederzijdse toestemming?',
                    'Is er in de situatie van Milan sprake van respect?',
                    'Is de situatie van Milan wel of niet oké?',
                ]}
                texts={[
                    'In de situatie van Milan is geen sprake van een goede context.\n' +
                    '\n' +
                    'Milan heeft geen veilige situatie om in op te groeien. Hij heeft weinig, kapotte en vieze kleding. Hij ' +
                    'gaat zonder eten naar school en heeft thuis te maken met ouders die veel ruzie maken.',

                    'In de situatie van Milan is geen sprake van bescherming.\n' +
                    '\n' +
                    'Milan wordt niet beschermd tegen lichamelijke- en emotionele mishandeling. Hij ziet dat zijn ouders ' +
                    'veel ruzie hebben en wordt uitgescholden en geslagen.',

                    'In de situatie van Milan is geen sprake van voldoende aandacht.\n' +
                    '\n' +
                    'Milan wordt in de ochtend niet geholpen door zijn ouders voordat hij naar school gaat. Wanneer hij ' +
                    'thuiskomt hebben zijn ouders ruzie en hebben geen aandacht voor hem.',

                    'In de situatie van Milan is geen sprake van vrijwilligheid.\n' +
                    '\n' +
                    'Milan wil dat de ruzie tussen zijn ouders stopt, als hij hier iets over zegt wordt hij uitgescholden en ' +
                    'geslagen.',

                    'In de situatie van Milan is geen sprake van toesteming.\n' +
                    '\n' +
                    'Milan geeft geen toestemming om uitgescholden en geslagen te worden. Hij vindt het niet fijn wat er ' +
                    'gebeurt en heeft hierin ook geen keuze.',

                    'In de situatie van Milan is geen sprake van respect.\n' +
                    '\n' +
                    'Milan wordt niet gerespecteerd. Hij wil dat de ruzie tussen zijn ouders stopt en hier wordt geen ' +
                    'rekening mee gehouden. In plaats daarvan zegt zijn vader dat Milan zich niet met hen moet bemoeien ' +
                    'en noemt hem een rotkind. Ook wordt er geen waardering uitgesproken naar Milan.',

                    'De situatie van Milan is niet oké. Hij heeft te maken met lichamelijke verwaarlozing, huiselijk geweld, ' +
                    'emotionele- en lichamelijke mishandeling.'
                ]}
    />,
    <Question title={'Hoe kunnen we Milan helpen?'} seconds={60} context={'Milan zou het fijn vinden als jij mee kunt denken over wat hem zou kunnen helpen. Vul jouw keuze in, zodat we samen het verschil kunnen maken voor Milan.'}/>,
    <ResultCloud id={103}
                 navigateDeviceNext={true}
                 answers={[
                     'Mijn meter',
                     'Ik mail een contactlijn',
                     'De leerkracht',
                     'Mijn neefje',
                     'OMA',
                     'Aangifte doen',
                     'Mijn beste vriendin',
                     'De schooldirectie',
                     'Mijn nonkel',
                     'OPA',
                     'Bellen naar een hulplijn',
                     'Child support',
                     'Mijn buurvrouw',
                     'mijn vrienden',
                     'Ik bel de politie',
                 ]}
                 level={1}/>,

    /**
     * Milou
     */
    <StartLevel level={2} text={'Het verhaal van Milou.'} navigateTo={15}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level2Animation1.mp4`}/>,
    <Question seconds={30} title={'Is het kindermishandeling als je voor bedtijd je telefoon moet inleveren?'} context={'Maak een keuze'}/>,
    <ResultAB id={201}
              question={'Is het kindermishandeling als je voor bedtijd je telefoon moet inleveren?'}
              answer={2}
              percentages={[66, 33]}
              screenshot={`${publicBuildUrl}images/screenshots/Level2Question1.png`}
              text={'Nee, het is geen kindermishandeling als je je telefoon voor bedtijd moet inleveren.'}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level2Animation2.mp4`}/>,
    <GameTimer text={'Probeer 5 keer na elkaar het bolletje in het vakje te krijgen en kraak het slot!'}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level2Animation3.mp4`}/>,
    <Question
        seconds={90}
        title={'Is de situatie van Milou wel of niet oké?'}
        context={'Beoordeel aan de hand van de tool ‘Miro’ of de situatie van Milou wel of niet oké is.'}
    />,
    <ResultTool id={202}
                navigateDeviceNext={true}
                questions={[
                    'Is er in de situatie van Milou sprake van een goede context?',
                    'Is er in de situatie van Milou sprake van bescherming?',
                    'Is er in de situatie van Milou sprake van voldoende aandacht?',
                    'Is er in de situatie van Milou sprake van vrijwilligheid?',
                    'Is er in de situatie van Milou sprake van wederzijdse toestemming?',
                    'Is er in de situatie van Milou sprake van respect?',
                    'Is de situatie van Milou wel of niet oké?',
                ]}
                texts={[
                    'In de situatie van Milou is geen sprake van een goede context.\n' +
                    '\n' +
                    'Milou heeft te maken met een onveilige situatie. De persoon die ongevraagd binnenkomt, de deur op ' +
                    'slot doet en haar aanraakt op plekken waar zij dat niet wil houdt geen rekening met haar privacy.',

                    'In de situatie van Milou is geen sprake van bescherming.\n' +
                    '\n' +
                    'Milou wordt niet beschermd tegen seksueel misbruik en emotionele mishandeling. Zij geeft aan dat zij ' +
                    'aangeraakt wordt op plekken waar zij dat niet wil. Ze krijgt opgelegd dat zij tegen niemand mag ' +
                    'vertellen wat er is gebeurd en er wordt gezegd dat zij het zelf ook fijn vindt, maar Milou vindt het ' +
                    'helemaal niet fijn.',

                    'In de situatie van Milou is geen sprake van voldoende aandacht.\n' +
                    '\n' +
                    'Milou krijgt ongepaste aandacht van iemand. Zij kan hier niet over vertellen omdat zij bang is voor de ' +
                    'gevolgen. Milou wil niemand boos maken of pijn doen en is bang dat niemand haar gelooft.',

                    'In de situatie van Milou is geen sprake van vrijwilligheid.\n' +
                    '\n' +
                    'Milou wordt aangeraakt op plekken waar zij dat niet wil, iemand komt ongevraagd haar kamer op en ' +
                    'doet de deur op slot zonder dat zij daarin een eigen keuze kan maken. Deze situatie is ongepast en ' +
                    'heeft nare gevolgen voor Milou.',

                    'In de situatie van Milou is geen sprake van toesteming.\n' +
                    '\n' +
                    'Milou heeft geen lichamelijke keuzevrijheid en kon niet weg uit de situatie. Milou kon niet zeggen dat ' +
                    'zij niet aangeraakt wilde worden, maar dat betekent niet dat er toestemming is.',

                    'In de situatie van Milou is geen sprake van respect.\n' +
                    '\n' +
                    'Milou wordt niet gerespecteerd. De persoon die Milou aanraakt op plekken waar zij dat niet wil en ' +
                    'ongevraagd haar kamer binnen komt heeft geen respect voor haar, omdat hij geen rekening houdt ' +
                    'met haar.',

                    'De situatie van Milou is niet oké. Zij heeft te maken met seksueel misbruik en emotionele mishandeling.'
                ]}
    />,
    <Question title={'Hoe kunnen we Milou helpen?'} seconds={60} context={'Milou zou het fijn vinden als jij mee kunt denken over wat haar zou kunnen helpen.\nVul jouw keuze in, zodat we samen het verschil kunnen maken voor Milou.'}/>,
    <ResultCloud id={203}
                 navigateDeviceNext={true}
                 answers={[
                     'Mijn meter',
                     'Ik mail een contactlijn',
                     'De leerkracht',
                     'Mijn neefje',
                     'OMA',
                     'Aangifte doen',
                     'Mijn beste vriendin',
                     'De schooldirectie',
                     'Mijn nonkel',
                     'OPA',
                     'Bellen naar een hulplijn',
                     'Child support',
                     'Mijn buurvrouw',
                     'mijn vrienden',
                     'Ik bel de politie',
                 ]}
                 level={2}/>,

    /**
     * Mila
     */
    <StartLevel level={3} text={'Het verhaal van Mila.'} navigateTo={26}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level3Animation1.mp4`}/>,
    <GameTimer text={'In dit spel laat je Miro vliegen, ondertussen komt hij allerlei obstakels tegen. Zorg ervoor dat Miro de obstakels niet raakt. Probeer dit zo lang mogelijk vol te houden om een highscore te behalen!'}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level3Animation2.mp4`}/>,
    <Question seconds={30} title={'Wat heb je gezien?'} context={'Maak een keuze\n(meerdere antwoorden zijn correct)'}/>,
    <ResultMultipleChoice
                          answer={[1, 0, 1, 1]}
                          options={[
                              'Mila is snel afgeleid',
                              'Mila vertelt tegen de juf wat er aan de hand is',
                              'Mila zit alleen op een bankje',
                              'Een volwassen jongen stuurt Mila een appje',
                          ]}
                          screenshot={`${publicBuildUrl}images/screenshots/Level3Question1.png`}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level3Animation3.mp4`}/>,
    <Question seconds={30} title={'Wat heb je gezien?'} context={'Maak een keuze\n(meerdere antwoorden zijn correct)'}/>,
    <ResultMultipleChoice
                          answer={[0, 1, 1, 0]}
                          options={[
                              'De ouders van Mila tonen interesse in haar',
                              'De ouders van Mila tonen geen interesse in haar',
                              'Mila maakt een foto zonder kleren',
                              'Mila maakt een foto met kleren',
                          ]}
                          screenshot={`${publicBuildUrl}images/screenshots/Level3Question2.png`}/>,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level3Animation4.mp4`}/>,
    <Question seconds={30} title={'Vragen de ouders aan Mila waarom zij een foto zonder kleren naar iemand heeft gestuurd?'} context={'Maak een keuze'}/>,
    <ResultAB
        id={303}
        question={'Resultaat'}
        answer={2}
        percentages={[12, 78]}
        screenshot={`${publicBuildUrl}images/screenshots/Level3Question3.png`}
        text={'Nee, de ouders van Mila vragen niet waarom zij dit heeft gedaan. Ze zeggen dat ze zich druk maken over wat anderen hiervan zullen denken en vinden het een schande.'}
    />,
    <Animation animation={`https://care-free.app/wp-content/uploads/2021/11/Level3Animation5.mp4`}/>,
    <Question
        seconds={90}
        title={'Is de situatie van Mila wel of niet oké?'}
        context={'Beoordeel aan de hand van de tool ‘Miro’ of de situatie van Mila wel of niet oké is.'}
    />,
    <ResultTool id={304}
                navigateDeviceNext={true}
                questions={[
                    'Is er in de situatie van Mila sprake van een goede context?',
                    'Is er in de situatie van Mila sprake van bescherming?',
                    'Is er in de situatie van Mila sprake van voldoende aandacht?',
                    'Is er in de situatie van Mila sprake van vrijwilligheid?',
                    'Is er in de situatie van Mila sprake van wederzijdse toestemming?',
                    'Is er in de situatie van Mila sprake van respect?',
                    'Is de situatie van Mila wel of niet oké?',
                ]}
                texts={[
                    'In de situatie van Mila is geen sprake van een goede context.\n' +
                    '\n' +
                    'Mila heeft te maken met een onveilige situatie. Er is geen zorg voor haar als zij wil bespreken dat zij ' +
                    'gepest wordt en wanneer een naaktfoto van haar is rondgestuurd.',

                    'In de situatie van Mila is geen sprake van bescherming.\n' +
                    '\n' +
                    'Mila wordt niet beschermd tegen emotionele mishandeling en seksueel misbruik. Zij krijgt geen ' +
                    'aandacht van haar ouders wanneer zij dit nodig heeft en een volwassen jongen vraagt en verspreid ' +
                    'haar naaktfoto.',

                    'In de situatie van Mila is geen sprake van voldoende aandacht.\n' +
                    '\n' +
                    'Mila vraagt zich af waarom er niet naar haar geluisterd wordt en waarom er nooit tijd voor haar ' +
                    'gemaakt wordt. Haar ouders hebben geen tijd als Mila met hen wil praten over het pesten. Wanneer ' +
                    'Mila te maken krijgt met de gevolgen van de naaktfoto stellen haar ouders hierover geen vragen aan ' +
                    'Mila, maar maken zich druk over wat andere mensen denken.',

                    'In de situatie van Mila is geen sprake van vrijwilligheid.\n' +
                    '\n' +
                    'Mila wordt gemanipuleerd door een volwassen jongen om een naaktfoto te sturen, hierdoor ' +
                    'voelt zij niet de ruimte om vrijwillig een keuze te maken. Bovendien is het niet gepast omdat ' +
                    'deze jongen volwassen is en dit heeft nare gevolgen voor Mila.',

                    'In de situatie van Mila is geen sprake van toesteming.\n' +
                    '\n' +
                    'Mila kon geen vrijwillige keuze maken doordat de volwassen jongen haar manipuleerde en ' +
                    'kon dus ook geen toestemming geven in deze situatie.',

                    'In de situatie van Mila is geen sprake van respect.\n' +
                    '\n' +
                    'Mila wordt niet gerespecteerd. Haar ouders hebben geen tijd voor haar als zij wil vertellen ' +
                    'dat ze gepest wordt. In plaats daarvan krijgt ze te horen dat het wel een reden zal hebben. ' +
                    'De volwassen jongen vraagt en verspreid de naaktfoto en houdt geen rekening met haar privacy.',

                    'De situatie van Mila is niet oké. Zij heeft te maken met emotionele mishandeling en seksueel misbruik.',
                ]}/>,
    <Question seconds={60} title={'Hoe kunnen we Mila helpen?'} context={'Mila zou het fijn vinden als jij mee kunt denken over wat haar zou kunnen helpen.\nVul jouw keuze in, zodat we samen het verschil kunnen maken voor Mila.'}/>,
    <ResultCloud id={305}
                 navigateDeviceNext={true}
                 answers={[
                     'Mijn meter',
                     'Ik mail een contactlijn',
                     'De leerkracht',
                     'Mijn neefje',
                     'OMA',
                     'Aangifte doen',
                     'Mijn beste vriendin',
                     'De schooldirectie',
                     'Mijn nonkel',
                     'OPA',
                     'Bellen naar een hulplijn',
                     'Child support',
                     'Mijn buurvrouw',
                     'mijn vrienden',
                     'Ik bel de politie',
                 ]}
                 level={3}/>,

    <EndCredits/>
];

export default map;
